import Image from "next/future/image";
import { useIntl } from "react-intl";

const Card = ({ item }) => {
  const { locale } = useIntl();
  return (
    <div className="card-item">
      <div className="icon flex-center">
        <Image
          src={item?.icon}
          alt="advantage-icon"
          width={80}
          height={80}
          loading="lazy"
          priority={false}
        />
      </div>
      <div className="content">
        <h3>{item?.title?.[locale]}</h3>
        <p>{item?.description?.[locale]}</p>
      </div>
      <div className="circle" />
    </div>
  );
};

export default Card;
